import type { UserWithPermission } from '../@types/UserWithPermission';
import type { Actions } from '../actions';
import {
  RCV_PERMISSION_LOOKUP,
  REQ_PERMISSION_LOOKUP,
  REQUEST_FAILED,
} from '../actions/permission-lookup';
import { requestStatus, responseStatus } from '../shared/statuses';

interface PermissionLookupState {
  requestStatus: number;
  responseStatus: number;
  users: UserWithPermission[] | null;
}

const _initialState: PermissionLookupState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  users: null,
};

const permissionLookupReducer = (
  state: PermissionLookupState = _initialState,
  action: Actions,
): PermissionLookupState => {
  switch (action.type) {
    case REQ_PERMISSION_LOOKUP:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_PERMISSION_LOOKUP:
      return {
        ...state,
        users: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default permissionLookupReducer;
